module.exports = {
  title: "COVID-19 (Coronavirus) Data Graphs By Country",
  titleshort: "stout-covid",
  company: "StoutLabs",
  description: `A COVID-19 graphing tool for world countries, US states, and US counties. Includes basic TA tools.`,
  keywords: ``,
  url: "https://covid.stoutlabs.com",
  imageRel: "src/images/gatsby-icon.png", // This must be relative to root!
  // below are absolute URLs of 'site image' and 'logo', which are used when sharing links on FB/Twitter/etc. (see SEO component)
  image: "https://covid.stoutlabs.com/site-image_v2.jpg",
  logo: "https://covid.stoutlabs.com/icons/icon-512x512.png",
  twitter: "@stoutlabs",
  // fbAppID: "1234567890",
  // ...etc
  pathPrefix: "",

  author: {
    name: "Daniel Stout",
    minibio: ``,
    something: ``,
  },
};
